import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Empty, Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";
import { AUTOMATION_ACTIONS } from "./enum";
import AutomationsHeader from "./AutomationsHeader/AutomationsHeader";
import AutomationsTable from "./AutomationsTable/AutomationsTable";
import AutomationsModal from "./modals/AutomationsModal";

const { IDLE, LOADING, ERROR, DATAMODE, NULLMODE } = dataQueryStatus;

const Automations = () => {
    const history = useHistory();
    const [status, setStatus] = useState(IDLE);
    const [errorMssg, setErrorMssg] = useState();
    const [automations, setAutomations] = useState([]);
    const [allAutomations, setAllAutomations] = useState([]);
    const [tableIsLoading, setTableIsLoading] = useState(false);
    const [searchIsLoading, setSearchIsLoading] = useState(false);
    const [clearSearch, setClearSearch] = useState(false);
    const [showModal, toggleModal] = useState(false);
    const [modalAction, setModalAction] = useState();
    const [selectedAutomation, setSelectedAutomation] = useState();

    const getAutomations = async () => {
        try {
            setErrorMssg();
            if (automations?.length < 1) {
                setStatus(LOADING);
            } else {
                setTableIsLoading(true);
            }

            const res = await API.get(apiRoute.getAutomations);

            if (res.status === 200) {
                const list = res?.data?.data || [];
                setAllAutomations(list);
                setAutomations(list);
                setStatus(list.length > 0 ? DATAMODE : NULLMODE);
            }
        } catch (err) {
            setErrorMssg(getErrorMessage(err));
            setStatus(ERROR);
        } finally {
            setTableIsLoading(false);
            setSearchIsLoading(false);
        }
    };

    useEffect(() => {
        getAutomations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearch = (search) => {
        setSearchIsLoading(true);
        setClearSearch(false);
        const query = (search || "").trim().toLowerCase();

        if (!query) {
            setAutomations(allAutomations);
            setStatus(allAutomations.length > 0 ? DATAMODE : NULLMODE);
            setSearchIsLoading(false);
            return;
        }

        const filtered = allAutomations.filter((item) =>
            item?.name?.toLowerCase?.()?.includes(query)
        );
        setAutomations(filtered);
        setStatus(filtered.length > 0 ? DATAMODE : NULLMODE);
        setSearchIsLoading(false);
    };

    const handleSuccess = () => {
        setClearSearch(true);
        getAutomations();
    };

    const handleActionModal = (actionType, automation) => {
        if (actionType === AUTOMATION_ACTIONS.EDIT_AUTOMATION) {
            history.push(`/t-sam/automation/${automation?.automationId}`);
            return;
        }

        setModalAction(actionType);
        setSelectedAutomation(automation);
        toggleModal(true);
    };

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return "";
            case LOADING:
                return <Loading />;
            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getAutomations}
                    />
                );
            case NULLMODE:
                return <Empty text='No automations available yet' />;
            case DATAMODE:
                return (
                    <AutomationsTable
                        automations={automations}
                        tableIsLoading={tableIsLoading}
                        handleActionModal={handleActionModal}
                        getAutomations={getAutomations}
                    />
                );
            default:
                return "";
        }
    };

    return (
        <>
            <div className='padded__layout pt-4'>
                <AutomationsHeader
                    handleClick={() => history.push("/t-sam/automation/new")}
                    handleSearch={handleSearch}
                    searchIsLoading={searchIsLoading}
                    clearSearch={clearSearch}
                />
                {renderBasedOnStatus()}
            </div>

            {showModal && (
                <AutomationsModal
                    showModal={showModal}
                    closeModal={() => toggleModal(false)}
                    modalAction={modalAction}
                    selectedAutomation={selectedAutomation}
                    handleSuccess={handleSuccess}
                />
            )}
        </>
    );
};

export default Automations;
